import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('union');
const type = createActionType('union');

export const INITIALIZE = type('Initialize');
export const INITIALIZE_CONFIG = type('InitializeConfig');
export const ADD_DATASET = type('AddDataset');
export const ADD_MAPPED_DATASET = type('AddMappedDataset');
export const REMOVE_DATASET = type('RemoveDataset');
export const SET_COLUMN_VALUE = type('SetColumnValue');
export const UPDATE_INPUT_COLUMN = type('UpdateInputColumn');
export const ADD_NEW_OUTPUT_COLUMN = type('AddNewOutputColumn');
export const UPDATE_OUTPUT_COLUMN = type('UpdateOutputColumn');
export const PREVIEW_UNION = type('PreviewUnion');
export const SELECT_DATASET = type('SelectDataset');
export const CHANGE_UNION_MODE = type('ChangeUnionMode');
export const SAVE_UNION_VIEW = type('SaveUnionView');
export const CREATE_UNION_VIEW = apiType('CreateUnionView');
export const UPDATE_UNION_VIEW = apiType('UpdateUnionView');
export const CLOSE_UNION_EDITOR = type('CloseUnionEditor');
export const RELOAD_PREVIEW = type('ReloadPreview');
export const REMOVE_OUTPUT_COLUMN = type('RemoveOutputColumn');
export const ADD_OUTPUT_COLUMNS = type('AddOutputColumns');
export const REORDER_OUTPUT_COLUMNS = type('ReorderOutputColumns');
